import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserLandscapeGame from 'src/games/LandscapingGame/Main';

interface LandscapingGameProps extends PageProps<{}> {
    onComplete: () => void;
}

class LandscapingGame extends React.Component<LandscapingGameProps> {
    constructor(props: LandscapingGameProps) {
        super(props);
        bindAllOfThis(this, LandscapingGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserLandscapeGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default LandscapingGame;



// WEBPACK FOOTER //
// ./src/pages/game/LandscapingGame.tsx